import * as C from '@/consts'
import logo from '@/assets/card-brands/amex-logomark-img-04.gif'

export default {
  // ブランドコード
  code: C.BRAND_AMEX,

  // ブランド判定
  match (number) {
    // 34, 37
    return /^3[47]/.test(number)
  },

  // カード番号のパターン
  pattern: [4, 6, 5],

  // ロゴ
  logo
}
